module.exports = __webpack_public_path__ + "img/1.a46d92f0.svg";